module.exports = new __parcel__URL__("cmip6-tas.839f7e42.png").toString();